'use client';

import { c as _c } from "react/compiler-runtime";
import { type RefCallback, useRef } from 'react';
import type { AppUpsellEntryPoint } from '@/config/app-upsells';
import { onEvent } from '@/events';
import type { AppUpsellSurface } from '@/events/app-upsells';
import { appUpsellProperties } from '@/lib/app-upsells/analytics';

/** Count a surface once per mount, only when actually visible (not hidden
 * sidebar duplicates, offscreen carousel slides, or below-fold content). */
export function useUpsellImpression(surface, t0, entryPoint) {
  const $ = _c(4);
  const active = t0 === undefined ? true : t0;
  const source = entryPoint ?? (surface === "dialog" ? "navigation" : surface);
  const recorded = useRef(false);
  let t1;
  if ($[0] !== active || $[1] !== source || $[2] !== surface) {
    t1 = element => {
      if (!active || !element || recorded.current) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(_temp)) {
          recorded.current = true;
          onEvent("app_upsell_viewed", appUpsellProperties(surface, source));
          observer.disconnect();
        }
      }, {
        threshold: 0.5
      });
      observer.observe(element);
      return () => observer.disconnect();
    };
    $[0] = active;
    $[1] = source;
    $[2] = surface;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(entry) {
  return entry.isIntersecting && entry.intersectionRatio >= 0.5;
}